const columns = [
    { accessorKey: 'utilityName', header: 'Utility', meta: { sortBy: 'UtilityName' }, cell: ({ getValue }) => getValue() ?? '—' },
    { accessorKey: 'billingTypeName', header: 'Billing type', meta: { sortBy: 'BillingTypeName' }, cell: ({ getValue }) => getValue() ?? '—' },
];
export default columns;
